<template>
  <div>
    <v-row class="mx-2 mb-5" justify="center">
      <v-col cols="12">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">
                項目
              </th>
              <th class="text-left">
                必須
              </th>
              <th class="text-left">
                入力制限内容
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="item in csvContents"
                :key="item.name"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.required }}</td>
              <td>{{ item.memo }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "CsvContents",

  data: () => ({
    csvContents : [
      {name: "担当者コード", required: '〇', memo :'半角英数12桁まで'},
      {name: "担当者名", required: '〇', memo :'50文字まで'},
      {name: "有効期限(from)", required: '〇', memo :'日付フォーマット(YYYYMMDD)で8桁'},
      {name: "有効期限(to)", required: '〇', memo :'日付フォーマット(YYYYMMDD)で8桁'},
      {name: "パスワード", required: '△', memo :'半角英数で8桁以上'},
      {name: "権限(店舗指定)", required: '〇', memo :'整数1桁まで(1: 店舗指定、2: 全店舗)'},
      {name: "店舗コード", required: '△', memo :'整数3桁まで 複数指定は|(パイプ記号)で区切る'},
    ]
  })
}
</script>